import { useMutation } from '@tanstack/react-query';

import { saveUserProfile } from '../api';

import { useResetUserProfile } from './use-reset-user-profile';
export const useSaveUserProfile = () => {
  const resetUserProfile = useResetUserProfile();

  return useMutation({
    mutationKey: ['saveUserProfile'],
    mutationFn: saveUserProfile,
    onSuccess: (_data) => {
      resetUserProfile();
    },
    onError: (_error) => {},
  });
};
